var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import getAnimation from '../../button/private/utils/buttonAnimations/getAnimation';
import getIconSize from '../../button/private/utils/buttonSizes/getIconSize';
import getButtonCommonStyles from '../../button/private/utils/buttonStyles/getButtonCommonStyles';
import getButtonVariants from '../../button/private/utils/buttonStyles/getButtonVariants';
import mergeClassnames from '../../mergeClassnames/mergeClassnames';
import getButtonSize from '../private/utils/getButtonSize';
const IconButtonComponent = (_a) => {
    var { variant, size, icon, disabled, animation, as, customClassName } = _a, rest = __rest(_a, ["variant", "size", "icon", "disabled", "animation", "as", "customClassName"]);
    const Component = as || 'button';
    return (React.createElement(Component, Object.assign({ className: mergeClassnames(getButtonSize(size), getButtonCommonStyles({ disabled }), getButtonVariants({ variant, disabled, animation }), animation === 'pulse' &&
            (variant === 'fill' || variant === 'primary') &&
            getAnimation('pulse'), animation === 'error' && getAnimation('error'), getIconSize(size), customClassName) }, ((!as || as === 'button') && { type: 'button' }), (disabled && { disabled }), rest)));
};
export default IconButtonComponent;
